import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ActiveToast, ToastrService } from 'ngx-toastr';
import { NotificationService } from 'projects/customer/src/app/shared/services/notification.service';
import { BehaviorSubject } from 'rxjs';

type AuthState = 'active' | 'expired';
@Injectable({
    providedIn: 'root'
})
export class LoaderService {
    // private isLoading = new BehaviorSubject<boolean>(false);
    // private state$ = new BehaviorSubject<AuthState>('active');
    // private handling = false;

    // constructor(
    //     private router: Router,
    //     private toastr: ToastrService
    // ) {}

    // showLoader() {
    //     this.isLoading.next(true);
    // }

    // hideLoader() {
    //     this.isLoading.next(false);
    // }

    // isLoading$() {
    //     return this.isLoading.asObservable();
    // }

    // markExpired() { if (this.state$.value !== 'expired') this.state$.next('expired'); }

    // reset() { this.state$.next('active'); }

    // isExpired(): boolean { return this.state$.value === 'expired'; }

    // notifyOnce(error?: any) {
    //     if (this.handling) return;
    //     this.handling = true;

    //     const isSessionError =
    //         error?.error?.message === 'invalid signature' ||
    //         error?.error?.message === 'invalid token' ||
    //         error?.error?.message === 'Token expired';

    //     this.toastr.error(
    //         isSessionError
    //             ? 'Session Expired, please login again'
    //             : 'Something went wrong, please try again',
    //     );

    //     try {
    //         localStorage.clear();
    //     } catch { }

    //     // flip global breaker
    //     this.markExpired();

    //     this.router.navigate(['/login']);
    // }

    // resetFlag() {
    //     this.handling = false;
    //     this.reset();
    // }


    


    private pendingCount = 0;
    private loadingSubject = new BehaviorSubject<boolean>(false);

    loading$ = this.loadingSubject.asObservable();

    show(): void {
        this.pendingCount++;
        this.loadingSubject.next(true);
    }

    hide(): void {
        if (this.pendingCount > 0) {
            this.pendingCount--;
        }

        if (this.pendingCount === 0) {
            this.loadingSubject.next(false);
        }
    }
}
